// Version <-> language mapping.
// Keep in sync with the versions offered in PassageReader / PlanModeReader.
export const KO_VERSIONS = ["KRV", "SAE", "ABB"];
export const EN_VERSIONS = ["ESV", "NIV", "NLT"];

const KO_SET = new Set(KO_VERSIONS);
const EN_SET = new Set(EN_VERSIONS);

const normalizeLanguage = (lang) => (lang && lang.toString().startsWith("ko") ? "ko" : "en");

// Returns true when `version` is in the current UI language's family.
export const isVersionInLanguage = (version, language) => {
  const bucket = normalizeLanguage(language) === "ko" ? KO_SET : EN_SET;
  return Boolean(version && bucket.has(version));
};

// Pick the best Bible version for a given UI language:
// - keep the user's saved default when it belongs to that language
// - otherwise fall back to the language's canonical default (KRV / ESV)
export const versionForLanguage = (language, savedDefault) => {
  if (isVersionInLanguage(savedDefault, language)) return savedDefault;
  return normalizeLanguage(language) === "ko" ? "KRV" : "ESV";
};
